import { compact, some } from 'lodash/fp';

import { BEST_SELLERS_PRODUCT_LIST } from '../../ahm-constants/ui';

// @ts-expect-error - Automatic, Please fix when editing this file
const isProductBestSeller = ({ scale, parentProductId, productId, productType }) =>
  // @ts-expect-error [🤖 PLEASE FIX 🤖]: Element implicitly has an 'any' type because expression of type 'any' can't be used to index type '{ readonly hospital: { readonly single: "starter-bronze"; readonly couple: "simple-bronze-plus"; readonly family: "essentials-silver-plus"; readonly "single-parent": "core-bronze-plus"; }; readonly extras: { ...; }; readonly package: { ...; }; }'.
  some((id) => id === BEST_SELLERS_PRODUCT_LIST?.[productType]?.[scale], compact([parentProductId, productId]));

export default isProductBestSeller;
